import { render, staticRenderFns } from "./IconChevronDoubleUpSolid.vue?vue&type=template&id=6367332d"
import script from "./IconChevronDoubleUpSolid.vue?vue&type=script&lang=js"
export * from "./IconChevronDoubleUpSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports